import { render } from "./Clasp.vue?vue&type=template&id=a4262440"
import script from "./Clasp.vue?vue&type=script&lang=js"
export * from "./Clasp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__